import React, { createContext, useContext, useState } from "react";
import en from "./i18n/en.json";
import de from "./i18n/de.json";

const translations = { en, de };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("lang") || "en"
  );

  function setLang(l) {
    setLangState(l);
    localStorage.setItem("lang", l);
  }

  // Resolve dot-notation key against the current language,
  // falling back to English if the key is missing.
  function t(key) {
    const resolve = (obj) =>
      key.split(".").reduce((o, k) => o?.[k], obj);
    return resolve(translations[lang]) ?? resolve(translations.en) ?? key;
  }

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
